import React from 'react';
import { FormErrorMessage } from 'src/shared/design-system/Input/Error/FormErrorMessage';
import Button, { ButtonType } from 'web-common/src/shared/design-system/components/Button';
import { BaseInput } from 'web-common/src/shared/design-system/components/Input';
import { AppleLogin } from '../oAuth/AppleLogin';
import { GoogleLoginV3 } from '../oAuth/GoogleLoginV3';
import { AuthType, EntryFormProps, useLoginOrSignUpEntryForm } from './useLoginOrSignUpEntryForm';

export const SignUpGateEntryForm: React.FC<EntryFormProps> = (props) => {
  const { email, onEmailChange, continueCTA } = props;
  const { error, emailError, loading, handleEmailContinue, handleKeyDown, showApple, googleProps, appleProps } =
    useLoginOrSignUpEntryForm(props);

  const providerError = error && error.type !== AuthType.EMAIL ? error.errorMessage : undefined;

  return (
    <form onSubmit={handleEmailContinue} onKeyDown={handleKeyDown} className='flex flex-col gap-2'>
      <div className='flex flex-col gap-2'>
        <GoogleLoginV3 {...googleProps} nonna />
        {showApple && <AppleLogin {...appleProps} nonna />}
      </div>
      {providerError ? <FormErrorMessage>{providerError}</FormErrorMessage> : null}
      {/* JA-WEIGHT-SHIM(1218377610766475): font-[600] renders Ja Bold under the shifted map; drop it for text-caption-700-caps when the map lands */}
      <p className='text-center text-caption-700-caps font-[600] text-eggplant-500'>Or</p>
      <fieldset className='flex flex-col gap-2 border-none p-0' disabled={loading}>
        <BaseInput
          label='Email'
          name='email'
          value={email}
          onChange={onEmailChange}
          errorMessage={emailError}
          hasError={!!emailError}
          data-cy='login-entry-email'
        />
        {error && error.type === AuthType.EMAIL ? <FormErrorMessage>{error.errorMessage}</FormErrorMessage> : null}
        <Button
          type='submit'
          buttonType={ButtonType.Primary}
          iconName='arrowRight'
          renderFullWidth
          disabled={loading}
          data-cy='login-entry-continue'>
          {continueCTA ?? 'Continue'}
        </Button>
      </fieldset>
    </form>
  );
};
